/**
 * Linkchooser Types of data-breed and data-link-type attributes.
 * This file lies here, not in Linkchooser, as it is used in multiple other components and causes Problems with
 * bundle splitting when in linkchooser dir.
 */
export enum LinkchooserLinkType {
  Page = 'page',
  Person = 'person',
  Attachment = 'attachment',
  External = 'external',
}
